/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import merge from 'lodash/merge';
import React, { ReactElement } from 'react';
import { getTooltipPointFormatterToFixedTwoDigits } from '../ChartDataFormatterUtils';
import { ChartItemKeys, chartSeriesContent, ChartType, PACKET_LOSS_ID } from '../ChartSeriesItems';
import ChartWrapper from './ChartWrapper';
import { defaultChartOptions, withTerminalHistoryChartHOCAndNoDataAvailableHOC } from './WithTerminalHistoryChartHOC';

interface PingSuccessChartProps {
  index: number;
  text: string;
  id: string;
  children: ReactElement | ReactElement[];
}
const PingSuccessChart = (props: PingSuccessChartProps) => {
  const { index, text, id, children } = props;
  const chartName = text;

  return (
    <ChartWrapper name={chartName} id={id} index={index} chartType={ChartItemKeys.packetLossPercentage}>
      {children}
    </ChartWrapper>
  );
};

const getChartOptions = () => {
  const defaultOptions = { ...defaultChartOptions(ChartType.line) };

  return merge(defaultOptions, {
    yAxis: [
      {
        min: 0,
        labels: {
          format: '{value} ms',
        },
        title: {
          text: 'Latency (ms)',
        },
      },
      {
        id: PACKET_LOSS_ID,
        min: 0,
        max: 20,
        tickInterval: 5,
        labels: {
          format: '{value}%',
        },
        title: {
          text: 'Packet Loss %',
        },
        opposite: true,
      },
    ],
    tooltip: {
      pointFormatter: getTooltipPointFormatterToFixedTwoDigits,
    },
    plotOptions: { series: { custom: { useDetailedLabelSymbols: true } } },
  });
};

export default withTerminalHistoryChartHOCAndNoDataAvailableHOC(
  PingSuccessChart,
  ChartType.line,
  getChartOptions(),
  chartSeriesContent[ChartItemKeys.packetLossPercentage],
  'pingGapSec',
);
